import * as React from 'react';
import { SVGProps } from 'react';

const IconNodesSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 3a1 1 0 0 0-1 1v1a3 3 0 0 1 0 6v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a3 3 0 1 1 0-6V4a1 1 0 0 0-1-1H3z" />
    <path d="M16 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
  </svg>
);
export default IconNodesSizeS;
